module.exports = __webpack_public_path__ + "static/img/cont3603.09a019f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3603.jpg
// module id = R6Vk
// module chunks = 0